import React from 'react'
import {Grid ,GridColumn} from "semantic-ui-react";
//import useAuth from '../../hooks/useAuth';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import {GET_CATEGORY, GETOFERT } from "../../../../gql/publication"
import "./HomeCategory.scss";
import FeedCategory from '../FedCategory/FedCategory';
import FedOfert from  '../FedCategory/FedOfert';
import Footer from '../../Footer/Footer';
import FooterExt from '../../FooterExt/FooterExt';


export default function HomeVenta() {
  //const auth = useAuth();
  //const {category} = props ;
  const {catego} = useParams () ;

  
 
  //console.log (useParams);
  const {data, loading}= useQuery(GET_CATEGORY,{
    variables: { category:catego } ,
  });

 const { data:data1, loading:loading1, } = useQuery ( GETOFERT,{
  variables: { ofert : catego },
});

if (loading || loading1) return null ;


  const {getPublicationsCatego} = data;

  const {getPublicationsOfert} = data1;

  

  
  


  
  return (

<>


    <Grid className='homecate' mobile ={16} computer= {16} >

      <Grid.Column centered mobile={16} computer={16} >


       {getPublicationsCatego[0] ? <FeedCategory  publication = {getPublicationsCatego}/>:
        <FedOfert  publication = {getPublicationsOfert}/> }

        
    </Grid.Column>

    
</Grid>
<GridColumn centered mobile= {16}  computer = {16}className='onos' >

        <Footer/>
    </GridColumn>




</>

  )


}
